import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Container, Typography } from '@mui/material';
// import from 'src/theme/overrides/Typography';




const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: { display: 'flex' },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function PublicLayout() {
  return (
    <>
      {/* <StyledHeader>
        <Logo />
      </StyledHeader> */}
      <StyledRoot className="backgroundStyle">
        <Container maxWidth="sm">
          <StyledContent>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
              <Box component="img" src="/assets/icons/ic_notification_mail.svg" sx={{cursor: 'pointer' }} />
            </Box>
            <Outlet />
          </StyledContent>
        </Container>
      </StyledRoot>

    </>
  );
}
